import { DEVICE_FEATURE_CATEGORIES, DEVICE_FEATURE_TYPES } from '../../../server/utils/constants';

export const LoginStatus = {
  Processing: 'Processing',
  WrongCredentialsError: 'WrongCredentialsError',
  WrongEmailError: 'WrongEmailError',
  WrongTwoFactorCodeError: 'WrongTwoFactorCodeError',
  LoginSuccess: 'LoginSuccess',
  UnknownError: 'UnknownError'
};

export const CreateUserErrors = {
  PasswordTooShort: 'PasswordTooShort',
  PasswordNotMatching: 'PasswordNotMatching',
  InvalidEmail: 'InvalidEmail',
  InstanceAlreadyConfigured: 'InstanceAlreadyConfigured'
};

export const ForgotPasswordStatus = {
  WrongEmailError: 'WrongEmailError',
  UserNotFound: 'UserNotFound'
};

export const ResetPasswordStatus = {
  ResetTokenNotFound: 'ResetTokenNotFound'
};

export const TelegramGetApiKeyStatus = {
  Getting: 'Getting',
  GetError: 'GetError',
  Success: 'Success'
};

export const TelegramSaveApiKeyStatus = {
  Saving: 'Saving',
  SavingError: 'SavingError',
  Success: 'Success'
};

export const DeviceGetByRoomStatus = {
  Getting: 'Getting',
  Success: 'Success',
  Error: 'Error'
};

export const SceneGetStatus = {
  Getting: 'Getting',
  Success: 'Success',
  Error: 'Error'
};

export const CalDAVStatus = {
  Getting: 'Getting',
  Success: 'Success',
  Error: 'Error',
  BadCredentialsError: 'BadCredentialsError',
  BadUrlError: 'BadUrlError',
  RetrievePrincipalUrlError: 'RetrievePrincipalUrlError',
  RetrieveHomeUrlError: 'RetrieveHomeUrlError',
  RequestCalendarsError: 'RequestCalendarsError',
  RequestChangesError: 'RequestChangesError',
  RequestEventsError: 'RequestEventsError'
};

export const CalendarGetEventsStatus = {
  Getting: 'Getting',
  GetError: 'GetError',
  Success: 'Success'
};

export const RequestStatus = {
  Getting: 'Getting',
  Success: 'Success',
  Error: 'Error',
  NetworkError: 'NetworkError',
  ConflictError: 'ConflictError',
  ValidationError: 'ValidationError',
  RateLimitError: 'RateLimitError',
  ServiceConnected: 'ServiceConnected',
  ServiceDisconnected: 'ServiceDisconnected',
  ServiceNotConfigured: 'ServiceNotConfigured',
  GatewayNoInstanceFound: 'GatewayNoInstanceFound',
  UserNotAcceptedLocally: 'UserNotAcceptedLocally',
  PhilipsHueBridgeButtonNotPressed: 'PhilipsHueBridgeButtonNotPressed',
  RoomConflictError: 'RoomConflictError',
  RoomValidationError: 'RoomValidationError'
};

export const GetWeatherStatus = {
  HouseHasNoCoordinates: 'HouseHasNoCoordinates',
  ServiceNotConfigured: 'ServiceNotConfigured',
  RequestToThirdPartyFailed: 'RequestToThirdPartyFailed'
};

export const GetWeatherModes = {
  DateLocation: 'dateLocation',
  CurrentWeather: 'currentWeather',
  Alerts: 'alerts',
  AdvancedWeather: 'advancedWeather',
  HourlyForecast: 'hourlyForecast',
  DailyForecast: 'dailyForecast',
  ProviderImages: 'providerImages'
};

// Modes enabled by default for widgets saved before they existed: the
// blocks the widget has always displayed unconditionally
export const DEFAULT_ON_WEATHER_MODES = [
  GetWeatherModes.DateLocation,
  GetWeatherModes.CurrentWeather,
  GetWeatherModes.Alerts
];

export const DASHBOARD_BOX_STATUS_KEY = 'DashboardBoxStatus';
export const DASHBOARD_BOX_DATA_KEY = 'DashboardBoxData';

export const DeviceFeatureCategoriesIcon = {
  [DEVICE_FEATURE_CATEGORIES.BATTERY]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'battery'
  },
  [DEVICE_FEATURE_CATEGORIES.BATTERY_LOW]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'battery'
  },
  [DEVICE_FEATURE_CATEGORIES.CAMERA]: {
    [DEVICE_FEATURE_TYPES.CAMERA.IMAGE]: 'camera',
    [DEVICE_FEATURE_TYPES.CAMERA.MOVE]: 'move',
    [DEVICE_FEATURE_TYPES.CAMERA.PRESET]: 'map-pin',
    [DEVICE_FEATURE_TYPES.CAMERA.PAN_POSITION]: 'crosshair',
    [DEVICE_FEATURE_TYPES.CAMERA.TILT_POSITION]: 'crosshair',
    [DEVICE_FEATURE_TYPES.CAMERA.ZOOM_POSITION]: 'crosshair'
  },
  [DEVICE_FEATURE_CATEGORIES.CHARGING_STATION]: {
    [DEVICE_FEATURE_TYPES.CHARGING_STATION.CONNECTOR_STATUS]: 'activity',
    [DEVICE_FEATURE_TYPES.CHARGING_STATION.CHARGING_STATE]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.DOORBELL]: {
    [DEVICE_FEATURE_TYPES.DOORBELL.RING]: 'bell'
  },
  [DEVICE_FEATURE_CATEGORIES.MOTION_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'eye',
    [DEVICE_FEATURE_TYPES.SENSOR.PUSH]: 'eye'
  },
  [DEVICE_FEATURE_CATEGORIES.PRESENCE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'users',
    [DEVICE_FEATURE_TYPES.SENSOR.PUSH]: 'users'
  },
  [DEVICE_FEATURE_CATEGORIES.SISMIC_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'activity'
  },
  [DEVICE_FEATURE_CATEGORIES.LIGHT]: {
    [DEVICE_FEATURE_TYPES.LIGHT.BINARY]: 'sun',
    [DEVICE_FEATURE_TYPES.LIGHT.BRIGHTNESS]: 'sun',
    [DEVICE_FEATURE_TYPES.LIGHT.HUE]: 'sun',
    [DEVICE_FEATURE_TYPES.LIGHT.COLOR]: 'sun',
    [DEVICE_FEATURE_TYPES.LIGHT.SATURATION]: 'sun',
    [DEVICE_FEATURE_TYPES.LIGHT.TEMPERATURE]: 'thermometer',
    [DEVICE_FEATURE_TYPES.LIGHT.POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.LIGHT.EFFECT_MODE]: 'play',
    [DEVICE_FEATURE_TYPES.LIGHT.EFFECT_SPEED]: 'activity'
  },
  [DEVICE_FEATURE_CATEGORIES.TEMPERATURE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'thermometer',
    [DEVICE_FEATURE_TYPES.TEMPERATURE_SENSOR.MIN]: 'thermometer',
    [DEVICE_FEATURE_TYPES.TEMPERATURE_SENSOR.MAX]: 'thermometer',
    [DEVICE_FEATURE_TYPES.TEMPERATURE_SENSOR.AVERAGE]: 'thermometer'
  },
  [DEVICE_FEATURE_CATEGORIES.DEVICE_TEMPERATURE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'cpu'
  },
  [DEVICE_FEATURE_CATEGORIES.VIBRATION_SENSOR]: {
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.BINARY]: 'alert-circle',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.STATUS]: 'alert-circle',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.TILT_ANGLE]: 'rotate-cw',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.ACCELERATION_X]: 'zap',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.ACCELERATION_Y]: 'zap',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.ACCELERATION_Z]: 'zap',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.ANGLE_X]: 'rotate-cw',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.ANGLE_Y]: 'rotate-cw',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.ANGLE_Z]: 'rotate-cw',
    [DEVICE_FEATURE_TYPES.VIBRATION_SENSOR.BED_ACTIVITY]: 'moon'
  },
  [DEVICE_FEATURE_CATEGORIES.COUNTER_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'plus'
  },
  [DEVICE_FEATURE_CATEGORIES.LIGHT_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'sun',
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'sun'
  },
  [DEVICE_FEATURE_CATEGORIES.SIGNAL]: {
    [DEVICE_FEATURE_TYPES.SIGNAL.QUALITY]: 'radio'
  },
  [DEVICE_FEATURE_CATEGORIES.SWITCH]: {
    [DEVICE_FEATURE_TYPES.SWITCH.BINARY]: 'power',
    [DEVICE_FEATURE_TYPES.SWITCH.BURGLAR]: 'users',
    [DEVICE_FEATURE_TYPES.SWITCH.POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.SWITCH.ENERGY]: 'zap',
    [DEVICE_FEATURE_TYPES.SWITCH.CURRENT]: 'zap',
    [DEVICE_FEATURE_TYPES.SWITCH.TARGET_CURRENT]: 'zap',
    [DEVICE_FEATURE_TYPES.SWITCH.VOLTAGE]: 'zap',
    [DEVICE_FEATURE_TYPES.SWITCH.DIMMER]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.AIR_CONDITIONING]: {
    [DEVICE_FEATURE_TYPES.AIR_CONDITIONING.BINARY]: 'power',
    [DEVICE_FEATURE_TYPES.AIR_CONDITIONING.MODE]: 'settings',
    [DEVICE_FEATURE_TYPES.AIR_CONDITIONING.TARGET_TEMPERATURE]: 'thermometer',
    [DEVICE_FEATURE_TYPES.AIR_CONDITIONING.FAN_SPEED]: 'wind',
    [DEVICE_FEATURE_TYPES.AIR_CONDITIONING.SWING_HORIZONTAL]: 'refresh-cw',
    [DEVICE_FEATURE_TYPES.AIR_CONDITIONING.SWING_VERTICAL]: 'refresh-cw'
  },
  [DEVICE_FEATURE_CATEGORIES.HEATER]: {
    [DEVICE_FEATURE_TYPES.HEATER.PILOT_WIRE_MODE]: 'thermometer'
  },
  [DEVICE_FEATURE_CATEGORIES.FAN]: {
    [DEVICE_FEATURE_TYPES.FAN.MODE]: 'wind',
    [DEVICE_FEATURE_TYPES.FAN.PERCENT]: 'bar-chart-2',
    [DEVICE_FEATURE_TYPES.FAN.SPEED]: 'bar-chart-2',
    [DEVICE_FEATURE_TYPES.FAN.AIRFLOW_DIRECTION]: 'repeat',
    [DEVICE_FEATURE_TYPES.FAN.ROCK_SETTING]: 'refresh-cw',
    [DEVICE_FEATURE_TYPES.FAN.WIND_SETTING]: 'moon'
  },
  [DEVICE_FEATURE_CATEGORIES.TELEVISION]: {
    [DEVICE_FEATURE_TYPES.TELEVISION.BINARY]: 'power',
    [DEVICE_FEATURE_TYPES.TELEVISION.SOURCE]: 'airplay',
    [DEVICE_FEATURE_TYPES.TELEVISION.GUIDE]: 'book-open',
    [DEVICE_FEATURE_TYPES.TELEVISION.MENU]: 'menu',
    [DEVICE_FEATURE_TYPES.TELEVISION.TOOLS]: 'settings',
    [DEVICE_FEATURE_TYPES.TELEVISION.INFO]: 'info',
    [DEVICE_FEATURE_TYPES.TELEVISION.ENTER]: 'corner-down-left',
    [DEVICE_FEATURE_TYPES.TELEVISION.RETURN]: 'rotate-ccw',
    [DEVICE_FEATURE_TYPES.TELEVISION.EXIT]: 'x',
    [DEVICE_FEATURE_TYPES.TELEVISION.LEFT]: 'chevron-left',
    [DEVICE_FEATURE_TYPES.TELEVISION.RIGHT]: 'chevron-right',
    [DEVICE_FEATURE_TYPES.TELEVISION.UP]: 'chevron-up',
    [DEVICE_FEATURE_TYPES.TELEVISION.DOWN]: 'chevron-down',
    [DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL_UP]: 'chevron-up',
    [DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL_DOWN]: 'chevron-down',
    [DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL_PREVIOUS]: 'chevrons-left',
    [DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL]: 'hash',
    [DEVICE_FEATURE_TYPES.TELEVISION.VOLUME_UP]: 'volume-2',
    [DEVICE_FEATURE_TYPES.TELEVISION.VOLUME_DOWN]: 'volume',
    [DEVICE_FEATURE_TYPES.TELEVISION.VOLUME_MUTE]: 'volume-x',
    [DEVICE_FEATURE_TYPES.TELEVISION.VOLUME]: 'volume-1',
    [DEVICE_FEATURE_TYPES.TELEVISION.PLAY]: 'play',
    [DEVICE_FEATURE_TYPES.TELEVISION.PAUSE]: 'pause',
    [DEVICE_FEATURE_TYPES.TELEVISION.STOP]: 'square',
    [DEVICE_FEATURE_TYPES.TELEVISION.PREVIOUS]: 'arrow-left',
    [DEVICE_FEATURE_TYPES.TELEVISION.NEXT]: 'arrow-right',
    [DEVICE_FEATURE_TYPES.TELEVISION.REWIND]: 'rewind',
    [DEVICE_FEATURE_TYPES.TELEVISION.FORWARD]: 'fast-forward',
    [DEVICE_FEATURE_TYPES.TELEVISION.RECORD]: 'circle'
  },
  [DEVICE_FEATURE_CATEGORIES.SHUTTER]: {
    [DEVICE_FEATURE_TYPES.SHUTTER.STATE]: 'sliders',
    [DEVICE_FEATURE_TYPES.SHUTTER.POSITION]: 'sliders'
  },
  [DEVICE_FEATURE_CATEGORIES.CURTAIN]: {
    [DEVICE_FEATURE_TYPES.CURTAIN.STATE]: 'sliders',
    [DEVICE_FEATURE_TYPES.CURTAIN.POSITION]: 'sliders'
  },
  [DEVICE_FEATURE_CATEGORIES.SMOKE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'alarm-smoke',
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'wind'
  },
  [DEVICE_FEATURE_CATEGORIES.LIGHT_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'sun',
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'sun'
  },
  [DEVICE_FEATURE_CATEGORIES.PRESSURE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'cloud',
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'cloud'
  },
  [DEVICE_FEATURE_CATEGORIES.SIREN]: {
    [DEVICE_FEATURE_TYPES.SIREN.BINARY]: 'bell',
    [DEVICE_FEATURE_TYPES.SIREN.LMH_VOLUME]: 'volume-1',
    [DEVICE_FEATURE_TYPES.SIREN.MELODY]: 'music',
    [DEVICE_FEATURE_TYPES.SIREN.TEST_IN_PROGRESS]: 'wrench'
  },
  [DEVICE_FEATURE_CATEGORIES.TAMPER]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'shield'
  },
  [DEVICE_FEATURE_CATEGORIES.CHILD_LOCK]: {
    [DEVICE_FEATURE_TYPES.CHILD_LOCK.BINARY]: 'lock'
  },
  [DEVICE_FEATURE_CATEGORIES.OPENING_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'info'
  },
  [DEVICE_FEATURE_CATEGORIES.LEAK_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'droplet'
  },
  [DEVICE_FEATURE_CATEGORIES.RAIN_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'umbrella'
  },
  [DEVICE_FEATURE_CATEGORIES.HUMIDITY_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'droplet'
  },
  [DEVICE_FEATURE_CATEGORIES.SOIL_MOISTURE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'droplet'
  },
  [DEVICE_FEATURE_CATEGORIES.PM25_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.PM10_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.FORMALDEHYD_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.NO2_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.O3_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.SO2_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.CO_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'alert-circle'
  },
  [DEVICE_FEATURE_CATEGORIES.CO2_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'bar-chart-2',
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.DISTANCE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'italic'
  },
  [DEVICE_FEATURE_CATEGORIES.LEVEL_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.DECIMAL]: 'droplet',
    [DEVICE_FEATURE_TYPES.LEVEL_SENSOR.LIQUID_STATE]: 'droplet',
    [DEVICE_FEATURE_TYPES.LEVEL_SENSOR.LIQUID_LEVEL_PERCENT]: 'droplet',
    [DEVICE_FEATURE_TYPES.LEVEL_SENSOR.LIQUID_DEPTH]: 'droplet'
  },
  [DEVICE_FEATURE_CATEGORIES.WATER_HEATER]: {
    [DEVICE_FEATURE_TYPES.WATER_HEATER.BINARY]: 'heater',
    [DEVICE_FEATURE_TYPES.WATER_HEATER.MODE]: 'sliders',
    [DEVICE_FEATURE_TYPES.WATER_HEATER.TARGET_TEMPERATURE]: 'thermometer',
    [DEVICE_FEATURE_TYPES.WATER_HEATER.REMAINING_HOT_WATER]: 'shower-head',
    [DEVICE_FEATURE_TYPES.WATER_HEATER.HEATING]: 'flame',
    [DEVICE_FEATURE_TYPES.WATER_HEATER.BOOST]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.WATER_VALVE]: {
    [DEVICE_FEATURE_TYPES.WATER_VALVE.CURRENT_DEVICE_STATUS]: 'droplet',
    [DEVICE_FEATURE_TYPES.WATER_VALVE.FLOW]: 'droplet',
    [DEVICE_FEATURE_TYPES.WATER_VALVE.AUTO_CLOSE_WHEN_WATER_SHORTAGE]: 'shield',
    [DEVICE_FEATURE_TYPES.WATER_VALVE.VALVE_WORK_STATE]: 'activity',
    [DEVICE_FEATURE_TYPES.WATER_VALVE.REAL_TIME_IRRIGATION_DURATION]: 'clock',
    [DEVICE_FEATURE_TYPES.WATER_VALVE.REAL_TIME_IRRIGATION_VOLUME]: 'droplet',
    [DEVICE_FEATURE_TYPES.WATER_VALVE.DAILY_IRRIGATION_VOLUME]: 'droplet'
  },
  [DEVICE_FEATURE_CATEGORIES.CUBE]: {
    [DEVICE_FEATURE_TYPES.CUBE.MODE]: 'activity',
    [DEVICE_FEATURE_TYPES.CUBE.ROTATION]: 'rotate-cw'
  },
  [DEVICE_FEATURE_CATEGORIES.BUTTON]: {
    [DEVICE_FEATURE_TYPES.BUTTON.CLICK]: 'circle',
    [DEVICE_FEATURE_TYPES.BUTTON.PUSH]: 'circle'
  },
  [DEVICE_FEATURE_CATEGORIES.ENERGY_SENSOR]: {
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.BINARY]: 'power',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.ENERGY]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.CURRENT]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.VOLTAGE]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.INDEX]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.INDEX_TODAY]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.INDEX_YESTERDAY]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.DAILY_CONSUMPTION]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.DAILY_CONSUMPTION_COST]: 'dollar-sign',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.THIRTY_MINUTES_CONSUMPTION]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_SENSOR.THIRTY_MINUTES_CONSUMPTION_COST]: 'dollar-sign'
  },
  [DEVICE_FEATURE_CATEGORIES.BATTERY_STORAGE]: {
    [DEVICE_FEATURE_TYPES.BATTERY_STORAGE.BATTERY_LEVEL]: 'battery',
    [DEVICE_FEATURE_TYPES.BATTERY_STORAGE.CHARGE_POWER]: 'battery-charging',
    [DEVICE_FEATURE_TYPES.BATTERY_STORAGE.DISCHARGE_POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.BATTERY_STORAGE.CHARGE_INDEX]: 'battery-charging',
    [DEVICE_FEATURE_TYPES.BATTERY_STORAGE.DISCHARGE_INDEX]: 'zap',
    [DEVICE_FEATURE_TYPES.BATTERY_STORAGE.BATTERY_ENERGY_REMAINING]: 'battery'
  },
  [DEVICE_FEATURE_CATEGORIES.ENERGY_PRODUCTION_SENSOR]: {
    [DEVICE_FEATURE_TYPES.ENERGY_PRODUCTION_SENSOR.POWER]: 'sun',
    [DEVICE_FEATURE_TYPES.ENERGY_PRODUCTION_SENSOR.INDEX]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_PRODUCTION_SENSOR.DAILY_PRODUCTION]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_PRODUCTION_SENSOR.DAILY_PRODUCTION_REVENUE]: 'dollar-sign',
    [DEVICE_FEATURE_TYPES.ENERGY_PRODUCTION_SENSOR.THIRTY_MINUTES_PRODUCTION]: 'zap',
    [DEVICE_FEATURE_TYPES.ENERGY_PRODUCTION_SENSOR.THIRTY_MINUTES_PRODUCTION_REVENUE]: 'dollar-sign'
  },
  [DEVICE_FEATURE_CATEGORIES.GRID_SENSOR]: {
    [DEVICE_FEATURE_TYPES.GRID_SENSOR.INPUT_POWER]: 'download',
    [DEVICE_FEATURE_TYPES.GRID_SENSOR.OUTPUT_POWER]: 'upload',
    [DEVICE_FEATURE_TYPES.GRID_SENSOR.POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.GRID_SENSOR.INPUT_INDEX]: 'download',
    [DEVICE_FEATURE_TYPES.GRID_SENSOR.OUTPUT_INDEX]: 'upload'
  },
  [DEVICE_FEATURE_CATEGORIES.HOME_OUTPUT_SENSOR]: {
    [DEVICE_FEATURE_TYPES.HOME_OUTPUT_SENSOR.POWER]: 'home',
    [DEVICE_FEATURE_TYPES.HOME_OUTPUT_SENSOR.INDEX]: 'home',
    [DEVICE_FEATURE_TYPES.HOME_OUTPUT_SENSOR.OFF_GRID_POWER]: 'power',
    [DEVICE_FEATURE_TYPES.HOME_OUTPUT_SENSOR.OFF_GRID_INDEX]: 'power'
  },
  [DEVICE_FEATURE_CATEGORIES.TELEINFORMATION]: {
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.BINARY]: 'power',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EAST]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EAIT]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF01]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF02]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF03]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF04]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF05]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF06]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF07]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF08]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF09]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASF10]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.PREF]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.PCOUP]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.VTIC]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.CCASN]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.CCASN_1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.UMOY1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.UMOY2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.UMOY3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ERQ1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ERQ2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ERQ3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ERQ4]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.IRMS1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.IRMS2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.IRMS3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.URMS1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.URMS2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.URMS3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASD01]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASD02]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASD03]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.EASD04]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.NTARF]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.CCAIN]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.CCAIN_1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SINSTI]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXIN]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXIN_1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXN]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXN2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXN3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SINSTS]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SINSTS2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SINSTS3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXN_1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXN2_1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.SMAXN3_1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.HHPHC]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.IMAX]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ADPS]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.IMAX2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.IMAX3]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ADIR1]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ADIR2]: 'zap',
    [DEVICE_FEATURE_TYPES.TELEINFORMATION.ADIR3]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.SPEED_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SPEED_SENSOR.DECIMAL]: 'wind',
    [DEVICE_FEATURE_TYPES.SPEED_SENSOR.INTEGER]: 'wind'
  },
  [DEVICE_FEATURE_CATEGORIES.UV_SENSOR]: {
    [DEVICE_FEATURE_TYPES.UV_SENSOR.INTEGER]: 'sun'
  },
  [DEVICE_FEATURE_CATEGORIES.PRECIPITATION_SENSOR]: {
    [DEVICE_FEATURE_TYPES.PRECIPITATION_SENSOR.DECIMAL]: 'umbrella',
    [DEVICE_FEATURE_TYPES.PRECIPITATION_SENSOR.INTEGER]: 'umbrella'
  },
  [DEVICE_FEATURE_CATEGORIES.CURRENCY]: {
    [DEVICE_FEATURE_TYPES.CURRENCY.DECIMAL]: 'dollar-sign'
  },
  [DEVICE_FEATURE_CATEGORIES.VOLUME_SENSOR]: {
    [DEVICE_FEATURE_TYPES.VOLUME_SENSOR.DECIMAL]: 'package',
    [DEVICE_FEATURE_TYPES.VOLUME_SENSOR.INTEGER]: 'package'
  },
  [DEVICE_FEATURE_CATEGORIES.DURATION]: {
    [DEVICE_FEATURE_TYPES.DURATION.DECIMAL]: 'watch',
    [DEVICE_FEATURE_TYPES.DURATION.INTEGER]: 'clock'
  },
  [DEVICE_FEATURE_CATEGORIES.VOC_SENSOR]: {
    [DEVICE_FEATURE_TYPES.VOC_SENSOR.DECIMAL]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.VOC_INDEX_SENSOR]: {
    [DEVICE_FEATURE_TYPES.VOC_INDEX_SENSOR.INTEGER]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.VOC_MATTER_INDEX_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.NO2_MATTER_INDEX_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.DATA]: {
    [DEVICE_FEATURE_TYPES.DATA.SIZE]: 'hard-drive'
  },
  [DEVICE_FEATURE_CATEGORIES.DATARATE]: {
    [DEVICE_FEATURE_TYPES.DATARATE.RATE]: 'activity'
  },
  [DEVICE_FEATURE_CATEGORIES.THERMOSTAT]: {
    [DEVICE_FEATURE_TYPES.THERMOSTAT.TARGET_TEMPERATURE]: 'thermometer',
    [DEVICE_FEATURE_TYPES.THERMOSTAT.MODE]: 'settings',
    [DEVICE_FEATURE_TYPES.THERMOSTAT.OPERATING_STATE]: 'power'
  },
  [DEVICE_FEATURE_CATEGORIES.AIRQUALITY_SENSOR]: {
    [DEVICE_FEATURE_TYPES.AIRQUALITY_SENSOR.AQI]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.PH_SENSOR]: {
    [DEVICE_FEATURE_TYPES.PH_SENSOR.DECIMAL]: 'droplet'
  },
  [DEVICE_FEATURE_CATEGORIES.ORP_SENSOR]: {
    [DEVICE_FEATURE_TYPES.ORP_SENSOR.DECIMAL]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.TEXT]: {
    [DEVICE_FEATURE_TYPES.TEXT.TEXT]: 'type',
    [DEVICE_FEATURE_TYPES.TEXT.SELECT]: 'list'
  },
  [DEVICE_FEATURE_CATEGORIES.SURFACE]: {
    [DEVICE_FEATURE_TYPES.SURFACE.DECIMAL]: 'crop'
  },
  [DEVICE_FEATURE_CATEGORIES.LOCK]: {
    [DEVICE_FEATURE_TYPES.LOCK.BINARY]: 'lock',
    [DEVICE_FEATURE_TYPES.LOCK.STATE]: 'sliders'
  },
  [DEVICE_FEATURE_CATEGORIES.NOISE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.ANGLE_SENSOR]: {
    [DEVICE_FEATURE_TYPES.SENSOR.INTEGER]: 'rotate-cw'
  },
  [DEVICE_FEATURE_CATEGORIES.UNKNOWN]: {
    [DEVICE_FEATURE_TYPES.UNKNOWN.UNKNOWN]: 'help-circle',
    [DEVICE_FEATURE_TYPES.SENSOR.BINARY]: 'help-circle'
  },
  [DEVICE_FEATURE_CATEGORIES.MUSIC]: {
    [DEVICE_FEATURE_TYPES.MUSIC.VOLUME]: 'volume-1',
    [DEVICE_FEATURE_TYPES.MUSIC.PLAY]: 'play',
    [DEVICE_FEATURE_TYPES.MUSIC.PAUSE]: 'pause',
    [DEVICE_FEATURE_TYPES.MUSIC.PREVIOUS]: 'rewind',
    [DEVICE_FEATURE_TYPES.MUSIC.NEXT]: 'fast-forward',
    [DEVICE_FEATURE_TYPES.MUSIC.PLAYBACK_STATE]: 'bar-chart-2',
    [DEVICE_FEATURE_TYPES.MUSIC.PLAY_NOTIFICATION]: 'bell'
  },
  [DEVICE_FEATURE_CATEGORIES.RISK]: {
    [DEVICE_FEATURE_TYPES.RISK.INTEGER]: 'alert-circle'
  },
  [DEVICE_FEATURE_CATEGORIES.INPUT]: {
    [DEVICE_FEATURE_TYPES.INPUT.BINARY]: 'arrow-right'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_BATTERY]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_BATTERY.BATTERY_ENERGY_REMAINING]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_BATTERY.BATTERY_LEVEL]: 'battery',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_BATTERY.BATTERY_POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_BATTERY.BATTERY_RANGE_ESTIMATE]: 'battery',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_BATTERY.BATTERY_TEMPERATURE]: 'thermometer',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_BATTERY.BATTERY_VOLTAGE]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_CHARGE]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_CURRENT]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_ENERGY_ADDED_TOTAL]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_ENERGY_CONSUMPTION_TOTAL]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_ON]: 'power',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_POWER]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_VOLTAGE]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.LAST_CHARGE_ENERGY_ADDED]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.LAST_CHARGE_ENERGY_CONSUMPTION]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.PLUGGED]: 'power',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.TARGET_CHARGE_LIMIT]: 'battery',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.TARGET_CURRENT]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_CLIMATE]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.CLIMATE_ON]: 'power',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.INDOOR_TEMPERATURE]: 'thermometer',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.TARGET_TEMPERATURE]: 'thermometer'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_COMMAND]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_COMMAND.ALARM]: 'bell',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_COMMAND.LOCK]: 'lock'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_DRIVE]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_DRIVE.DRIVE_ENERGY_CONSUMPTION_TOTAL]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_DRIVE.SPEED]: 'wind'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_CONSUMPTION]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CONSUMPTION.ENERGY_CONSUMPTION]: 'zap',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CONSUMPTION.ENERGY_EFFICIENCY]: 'zap'
  },
  [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_STATE]: {
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_STATE.DOOR_OPENED]: 'unlock',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_STATE.ODOMETER]: 'trending-up',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_STATE.TIRE_PRESSURE]: 'disc',
    [DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_STATE.WINDOW_OPENED]: 'square'
  },
  [DEVICE_FEATURE_CATEGORIES.HEPA_FILTER_MONITORING]: {
    [DEVICE_FEATURE_TYPES.FILTER_MONITORING.FILTER_LIFE_REMAINING]: 'bar-chart-2'
  },
  [DEVICE_FEATURE_CATEGORIES.MAINTENANCE]: {
    [DEVICE_FEATURE_TYPES.MAINTENANCE.LIFE_REMAINING]: 'tool'
  },
  [DEVICE_FEATURE_CATEGORIES.VACUUM_CLEANER]: {
    [DEVICE_FEATURE_TYPES.VACUUM_CLEANER.STATE]: 'disc',
    [DEVICE_FEATURE_TYPES.VACUUM_CLEANER.RUN_MODE]: 'settings',
    [DEVICE_FEATURE_TYPES.VACUUM_CLEANER.CLEAN_MODE]: 'settings',
    [DEVICE_FEATURE_TYPES.VACUUM_CLEANER.DOCK]: 'home'
  }
};

export const DeviceFeatureTypesString = [DEVICE_FEATURE_TYPES.TEXT.TEXT, DEVICE_FEATURE_TYPES.TEXT.SELECT];

// Television and music features come in two flavours: continuous controls, which carry a value the
// user reads and adjusts, and remote-control orders, which are one-shot commands with no meaningful
// value to display. Only the continuous ones are listed here: everything else in those categories is
// a push button, so a new DEVICE_FEATURE_TYPES.TELEVISION.* / .MUSIC.* is handled without touching
// this file. These sets are the single source of truth for both the dashboard rows and the MQTT
// device catalog defaults.
export const TelevisionContinuousControlFeatureTypes = new Set([
  DEVICE_FEATURE_TYPES.TELEVISION.BINARY,
  DEVICE_FEATURE_TYPES.TELEVISION.VOLUME,
  DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL
]);

export const MusicContinuousControlFeatureTypes = new Set([
  DEVICE_FEATURE_TYPES.MUSIC.VOLUME,
  DEVICE_FEATURE_TYPES.MUSIC.PLAYBACK_STATE
]);

export const isPushButtonFeature = (category, type) => {
  if (category === DEVICE_FEATURE_CATEGORIES.BUTTON && type === DEVICE_FEATURE_TYPES.BUTTON.PUSH) {
    return true;
  }

  if (category === DEVICE_FEATURE_CATEGORIES.TELEVISION) {
    return !TelevisionContinuousControlFeatureTypes.has(type);
  }

  // MUSIC.PLAY_NOTIFICATION lands here and is reported as a push button, which is how the MQTT
  // catalog has always classified it. It is not a plain key: scene.actions.js calls it with a TTS
  // URL, so it must be excluded before this predicate is used to route music onto a dashboard push
  // button row. It is left as-is here because narrowing it would silently change the MQTT catalog
  // defaults (a 0-100 slider instead of a one-shot button), which is no more correct for a URL.
  if (category === DEVICE_FEATURE_CATEGORIES.MUSIC) {
    return !MusicContinuousControlFeatureTypes.has(type);
  }

  return false;
};

export const TelevisionPushButtonFeatureTypes = Object.values(DEVICE_FEATURE_TYPES.TELEVISION).filter(type =>
  isPushButtonFeature(DEVICE_FEATURE_CATEGORIES.TELEVISION, type)
);
